type Entry = { ar: string; en: string };

export const dictionary = {
  "orders.status.awaiting_payment": {
    en: "Awaiting payment",
    ar: "بانتظار الدفع",
  },
  "orders.status.preparing": { en: "Preparing", ar: "قيد التحضير" },
  "orders.status.ready": { en: "Ready for handoff", ar: "جاهز للتسليم" },
  "orders.status.rejected": { en: "Rejected", ar: "مرفوض" },
  "orders.status.unknown": { en: "Status unavailable", ar: "الحالة غير متاحة" },
  "orders.tip": { en: "Tip", ar: "الإكرامية" },
  "orders.asap": { en: "As soon as possible", ar: "في أقرب وقت" },
  "orders.pickupAddress": { en: "Pickup address", ar: "عنوان الاستلام" },
  "orders.timeline": { en: "Order timeline", ar: "مراحل الطلب" },
  "orders.placed": { en: "Order placed", ar: "تم إرسال الطلب" },
  "orders.selectedLocation": {
    en: "Your selected delivery location",
    ar: "موقع التوصيل الذي اخترته",
  },
  "orders.addonsIncluded": { en: "includes add-ons", ar: "يشمل الإضافات" },
  "orders.salePrice": { en: "Sale price", ar: "سعر التخفيض" },
  "orders.paymentStatus": { en: "Payment status", ar: "حالة الدفع" },
  "orders.paymentNotice.awaiting": {
    en: "Your payment has not been confirmed yet.",
    ar: "لم يتم تأكيد دفعك بعد.",
  },
  "orders.paymentNotice.failed": {
    en: "Your payment attempt failed.",
    ar: "فشلت محاولة الدفع.",
  },
  "orders.paymentNotice.expired": {
    en: "The payment window has expired.",
    ar: "انتهت مهلة الدفع.",
  },
  "orders.cashNotCollected": {
    en: "Cash not collected",
    ar: "لم يُحصّل النقد",
  },
  "orders.cashDuePickup": {
    en: "Pay cash when you collect your order",
    ar: "ادفع نقداً عند استلام طلبك",
  },
  "orders.cashDueDelivery": {
    en: "Pay cash when your order arrives",
    ar: "ادفع نقداً عند وصول طلبك",
  },
  "payment.status.unpaid": { en: "Unpaid", ar: "غير مدفوع" },
  "payment.status.failed": { en: "Payment failed", ar: "فشل الدفع" },
  "payment.status.paid": { en: "Paid", ar: "مدفوع" },
  "payment.status.processing": {
    en: "Payment processing",
    ar: "جارٍ معالجة الدفع",
  },
  "payment.status.partially_refunded": {
    en: "Partially refunded",
    ar: "مسترد جزئياً",
  },
  "payment.status.refunded": { en: "Refunded", ar: "مسترد" },
  "payment.status.expired": {
    en: "Payment window expired",
    ar: "انتهت مهلة الدفع",
  },
  "payment.status.review_required": {
    en: "Payment under review",
    ar: "الدفع قيد المراجعة",
  },
  "payment.status.unknown": {
    en: "Status unavailable",
    ar: "الحالة غير متاحة",
  },
  "nav.home": { ar: "الرئيسية", en: "Home" },
  "nav.branches": { ar: "الفروع", en: "Branches" },
  "nav.menu": { ar: "المنيو", en: "Menu" },
  "nav.account": { ar: "حسابي", en: "My account" },
  "nav.orders": { ar: "طلباتي", en: "My orders" },
  "nav.loyalty": { ar: "نقاطي", en: "My points" },
  "nav.signin": { ar: "تسجيل الدخول", en: "Sign in" },
  "nav.logout": { ar: "تسجيل الخروج", en: "Sign out" },
  "nav.openMenu": { ar: "فتح القائمة", en: "Open menu" },
  "nav.closeMenu": { ar: "إغلاق القائمة", en: "Close menu" },
  "nav.cart": { ar: "السلة", en: "Cart" },
  "nav.language": { ar: "اللغة", en: "Language" },
  "nav.languageEnglish": { ar: "الإنجليزية", en: "English" },
  "nav.languageArabic": { ar: "العربية", en: "Arabic" },
  "nav.skip": { ar: "تخطي إلى المحتوى", en: "Skip to content" },

  "seo.cartDescription": {
    ar: "راجع أصناف سلتك قبل إتمام الطلب.",
    en: "Review the items in your cart before checkout.",
  },
  "seo.paymentStatusTitle": { ar: "حالة الدفع", en: "Payment status" },
  "seo.paymentStatusDescription": {
    ar: "تحقق من حالة الدفع وواصل طلبك.",
    en: "Check your payment status and continue your order.",
  },
  "seo.paymentLinkDescription": {
    ar: "راجع تفاصيل طلبك وأكمل الدفع بأمان.",
    en: "Review your order details and complete payment securely.",
  },
  "seo.orderLinkTitle": { ar: "رابط الطلب", en: "Order link" },
  "seo.orderLinkDescription": {
    ar: "افتح رابط طلبك للمتابعة.",
    en: "Open your order link to continue.",
  },

  "footer.rights": {
    ar: "© {year} {brand}. جميع الحقوق محفوظة.",
    en: "© {year} {brand}. All rights reserved.",
  },
  "footer.powered": {
    ar: "الطلب الإلكتروني بواسطة Emynor",
    en: "Online ordering powered by Emynor",
  },
  "footer.privacy": { ar: "سياسة الخصوصية", en: "Privacy Policy" },
  "footer.terms": { ar: "الشروط والأحكام", en: "Terms & Conditions" },
  "footer.returns": { ar: "سياسة الاسترجاع", en: "Return Policy" },
  "footer.explore": { ar: "استكشف", en: "Explore" },
  "footer.contact": { ar: "تواصل معنا", en: "Contact" },
  "footer.social": { ar: "تابعنا", en: "Follow us" },
  "footer.legal": { ar: "المعلومات القانونية", en: "Legal" },
  "footer.callUs": { ar: "اتصل بنا", en: "Call us" },
  "footer.poweredPrefix": {
    ar: "الطلب الإلكتروني بواسطة",
    en: "Online ordering powered by",
  },
  "footer.emynorLink": {
    ar: "زيارة موقع Emynor (يفتح في نافذة جديدة)",
    en: "Visit Emynor (opens in a new tab)",
  },

  "common.loading": { ar: "جارٍ التحميل…", en: "Loading…" },
  "common.retry": { ar: "إعادة المحاولة", en: "Try again" },
  "common.error": { ar: "تعذّر تحميل البيانات", en: "We couldn't load this" },
  "paymentLink.loading": {
    ar: "جارٍ تحميل رابط الدفع…",
    en: "Loading payment link…",
  },
  "paymentLink.notFoundTitle": {
    ar: "رابط الدفع غير متاح",
    en: "Payment link unavailable",
  },
  "paymentLink.notFoundBody": {
    ar: "قد يكون الرابط غير صحيح أو لم يعد صالحًا. اطلب رابطًا جديدًا من المطعم.",
    en: "The link may be incorrect or no longer valid. Ask the restaurant for a new link.",
  },
  "paymentLink.title": { ar: "دفع الطلب", en: "Pay for your order" },
  "paymentLink.orderNumber": { ar: "رقم الطلب", en: "Order" },
  "paymentLink.customer": { ar: "العميل", en: "Customer" },
  "paymentLink.total": { ar: "الإجمالي", en: "Total" },
  "paymentLink.reviewOrder": { ar: "راجع طلبك", en: "Review your order" },
  "paymentLink.branch": { ar: "الفرع", en: "Branch" },
  "paymentLink.fulfillment": { ar: "طريقة الاستلام", en: "Order type" },
  "paymentLink.delivery": { ar: "توصيل", en: "Delivery" },
  "paymentLink.pickup": { ar: "استلام من الفرع", en: "Pickup" },
  "paymentLink.requestedTime": { ar: "الوقت المطلوب", en: "Requested time" },
  "paymentLink.asap": { ar: "في أقرب وقت", en: "As soon as possible" },
  "paymentLink.address": { ar: "عنوان التوصيل", en: "Delivery address" },
  "paymentLink.deliveryInstructions": {
    ar: "تعليمات التوصيل",
    en: "Delivery instructions",
  },
  "paymentLink.notes": { ar: "ملاحظات الطلب", en: "Order notes" },
  "paymentLink.each": { ar: "للقطعة", en: "each" },
  "paymentLink.subtotal": { ar: "المجموع الفرعي", en: "Subtotal" },
  "paymentLink.discount": { ar: "الخصم", en: "Discount" },
  "paymentLink.deliveryFee": { ar: "رسوم التوصيل", en: "Delivery fee" },
  "paymentLink.serviceFee": { ar: "رسوم الخدمة", en: "Service fee" },
  "paymentLink.tip": { ar: "البقشيش", en: "Tip" },
  "paymentLink.awaitingTitle": {
    ar: "الطلب بانتظار الدفع",
    en: "Awaiting payment",
  },
  "paymentLink.awaitingBody": {
    ar: "لن يبدأ المطعم تجهيز الطلب حتى يتم تأكيد الدفع.",
    en: "The restaurant will start the order after payment is confirmed.",
  },
  "paymentLink.paidTitle": { ar: "تم الدفع بنجاح", en: "Payment confirmed" },
  "paymentLink.paidBody": {
    ar: "وصل الطلب إلى المطعم وبدأت متابعته.",
    en: "The order has been sent to the restaurant.",
  },
  "paymentLink.failedTitle": {
    ar: "لم تكتمل عملية الدفع",
    en: "Payment was not completed",
  },
  "paymentLink.failedBody": {
    ar: "تواصل مع المطعم للحصول على رابط دفع جديد.",
    en: "Contact the restaurant for a new payment link.",
  },
  "paymentLink.expiredTitle": {
    ar: "انتهت صلاحية الرابط",
    en: "Payment link expired",
  },
  "paymentLink.expiredBody": {
    ar: "تواصل مع المطعم لإنشاء طلب أو رابط جديد.",
    en: "Contact the restaurant to create a new order or link.",
  },
  "paymentLink.cancelledTitle": {
    ar: "تم إلغاء الرابط",
    en: "Payment link cancelled",
  },
  "paymentLink.cancelledBody": {
    ar: "أوقف المطعم هذا الرابط. تواصل معه إذا كنت ما زلت تريد الطلب.",
    en: "The restaurant stopped this link. Contact them if you still want the order.",
  },
  "paymentLink.reviewTitle": {
    ar: "الدفع قيد المراجعة",
    en: "Payment under review",
  },
  "paymentLink.reviewBody": {
    ar: "لا تحاول الدفع مرة أخرى. سيتحقق المطعم من العملية.",
    en: "Do not pay again. The restaurant will verify the transaction.",
  },
  "paymentLink.payNow": { ar: "ادفع الآن — {total}", en: "Pay now — {total}" },
  "paymentLink.preparing": {
    ar: "جارٍ تجهيز الدفع الآمن…",
    en: "Preparing secure payment…",
  },
  "paymentLink.secureHelp": {
    ar: "سيتم الدفع في صفحة مزود الدفع الآمنة. لا تشارك هذا الرابط مع أي شخص آخر.",
    en: "Payment continues on the provider's secure page. Do not share this link with anyone else.",
  },
  "errors.minimumOrderTitle": {
    ar: "لم يصل الطلب إلى الحد الأدنى",
    en: "Minimum order not reached",
  },
  "errors.minimumOrder": {
    ar: "لم يصل طلبك إلى الحد الأدنى المطلوب لهذه الخدمة.",
    en: "Your order has not reached the minimum value for this service.",
  },
  "errors.paymentUnavailableTitle": {
    ar: "وسيلة الدفع غير متاحة",
    en: "Payment method unavailable",
  },
  "errors.paymentUnavailable": {
    ar: "وسيلة الدفع هذه غير متاحة مؤقتًا. اختر وسيلة أخرى.",
    en: "This payment method is temporarily unavailable. Choose another method.",
  },
  "errors.storefrontUnavailableTitle": {
    ar: "الطلب غير متاح مؤقتًا",
    en: "Ordering is temporarily unavailable",
  },
  "errors.storefrontUnavailable": {
    ar: "لا يستقبل هذا المطعم طلبات جديدة في الوقت الحالي. حاول مرة أخرى لاحقًا.",
    en: "This restaurant is not accepting new orders at the moment. Please try again later.",
  },
  "errors.orderTypeUnavailableTitle": {
    ar: "طريقة الطلب غير متاحة",
    en: "Ordering option unavailable",
  },
  "errors.orderTypeUnavailable": {
    ar: "طريقة الطلب المحددة متوقفة حاليًا. اختر طريقة أخرى أو حاول مرة أخرى لاحقًا.",
    en: "That ordering option is currently paused. Choose another option or try again later.",
  },
  "errors.asapUnavailable": {
    ar: "الطلبات الفورية متوقفة حاليًا. اختر موعدًا لاحقًا أو حاول مرة أخرى لاحقًا.",
    en: "ASAP ordering is currently paused. Schedule for later or try again later.",
  },
  "errors.scheduledUnavailable": {
    ar: "الطلبات المجدولة متوقفة حاليًا. اختر الطلب الفوري أو حاول مرة أخرى لاحقًا.",
    en: "Scheduled ordering is currently paused. Choose ASAP or try again later.",
  },
  "errors.branchUnavailableTitle": {
    ar: "الفرع لا يستقبل طلبات الآن",
    en: "This branch is not accepting orders",
  },
  "errors.branchUnavailable": {
    ar: "الفرع مشغول ولا يستقبل طلبات في الوقت الحالي. اختر فرعًا آخر أو حاول مرة أخرى لاحقًا.",
    en: "This branch is busy and is not accepting orders at the moment. Choose another branch or try again later.",
  },
  "errors.itemUnavailableTitle": {
    ar: "الصنف غير متاح",
    en: "This item is unavailable",
  },
  "errors.itemUnavailable": {
    ar: "هذا الصنف غير متاح من الفرع المحدد حاليًا. احذفه من السلة أو اختر صنفًا آخر ثم حاول مرة أخرى.",
    en: "This item is not available from the selected branch right now. Remove it or choose another item, then try again.",
  },
  "errors.itemUnavailableNamedTitle": {
    ar: "الصنف «{item}» غير متاح",
    en: "{item} is unavailable",
  },
  "errors.itemUnavailableNamed": {
    ar: "لم يعد الصنف «{item}» متاحًا للطلب. احذفه من السلة أو اختر صنفًا آخر ثم حاول مرة أخرى.",
    en: "{item} is no longer available to order. Remove it from your cart or choose another item, then try again.",
  },
  "errors.variantUnavailableTitle": {
    ar: "الخيار غير متاح",
    en: "This option is unavailable",
  },
  "errors.variantUnavailable": {
    ar: "الحجم أو الخيار المحدد لم يعد متاحًا. اختر خيارًا آخر ثم حاول مرة أخرى.",
    en: "The selected size or option is no longer available. Choose another option and try again.",
  },
  "errors.addonUnavailableTitle": {
    ar: "إحدى الإضافات غير متاحة",
    en: "An add-on is unavailable",
  },
  "errors.addonUnavailable": {
    ar: "إحدى الإضافات المحددة لم تعد متاحة. راجع اختياراتك ثم حاول مرة أخرى.",
    en: "One of the selected add-ons is no longer available. Review your choices and try again.",
  },
  "errors.deliveryUnavailableTitle": {
    ar: "التوصيل غير متاح لهذا العنوان",
    en: "Delivery is unavailable here",
  },
  "errors.deliveryUnavailable": {
    ar: "التوصيل غير متاح لهذا العنوان حاليًا. جرّب عنوانًا آخر أو اختر الاستلام من الفرع.",
    en: "Delivery is not available for this address right now. Try another address or choose pickup.",
  },
  "errors.deliveryDisabled": {
    ar: "أوقف المطعم خدمة التوصيل مؤقتًا. اختر الاستلام من الفرع أو حاول مرة أخرى لاحقًا.",
    en: "The restaurant has temporarily paused delivery. Choose pickup or try again later.",
  },
  "errors.customerUnavailableTitle": {
    ar: "لا يمكن إكمال الطلب بهذا الحساب",
    en: "This account cannot place an order",
  },
  "errors.customerUnavailable": {
    ar: "لا يمكن استخدام هذا الحساب لإرسال طلب جديد حاليًا. تواصل مع المطعم إذا كنت بحاجة إلى المساعدة.",
    en: "This account cannot place a new order right now. Contact the restaurant if you need help.",
  },
  "errors.quoteExpiredTitle": {
    ar: "يجب تحديث السلة",
    en: "Your cart needs an update",
  },
  "errors.quoteExpired": {
    ar: "انتهت صلاحية إجمالي السلة. حدّث الإجمالي ثم حاول مرة أخرى.",
    en: "Your cart total has expired. Update the total and try again.",
  },
  "errors.requestInProgressTitle": {
    ar: "طلبك قيد المعالجة",
    en: "Your order is being processed",
  },
  "errors.requestInProgress": {
    ar: "نعالج هذا الطلب بالفعل. انتظر قليلًا قبل المحاولة مرة أخرى لتجنب إرسال الطلب مرتين.",
    en: "We are already processing this order. Wait a moment before trying again to avoid submitting it twice.",
  },
  "errors.fulfillmentTime": {
    ar: "موعد الاستلام المحدد لم يعد متاحًا. اختر موعدًا آخر.",
    en: "The selected pickup time is no longer available. Choose another time.",
  },
  "errors.deliveryAddress": {
    ar: "أكمل عنوان التوصيل وحدد موقعه على الخريطة ثم حاول مرة أخرى.",
    en: "Complete the delivery address and confirm its map location, then try again.",
  },
  "errors.customerDetails": {
    ar: "تحقق من الاسم ورقم الهاتف ثم حاول مرة أخرى.",
    en: "Check the customer name and phone number, then try again.",
  },
  "errors.promotionTitle": {
    ar: "تعذّر تطبيق العرض",
    en: "Offer could not be applied",
  },
  "common.errorHint": {
    ar: "تحقق من اتصالك بالإنترنت ثم أعد المحاولة.",
    en: "Check your connection and try again.",
  },
  "common.empty": { ar: "لا توجد نتائج", en: "Nothing here yet" },
  "common.search": { ar: "بحث", en: "Search" },
  "common.close": { ar: "إغلاق", en: "Close" },
  "common.cancel": { ar: "إلغاء", en: "Cancel" },
  "common.confirm": { ar: "تأكيد", en: "Confirm" },
  "common.save": { ar: "حفظ", en: "Save" },
  "common.change": { ar: "تغيير", en: "Change" },
  "common.back": { ar: "رجوع", en: "Back" },
  "common.loadMore": { ar: "عرض المزيد", en: "Load more" },
  "common.all": { ar: "الكل", en: "All" },
  "common.next": { ar: "التالي", en: "Next" },
  "common.previous": { ar: "السابق", en: "Previous" },
  "common.quantity": { ar: "الكمية", en: "Quantity" },
  "common.note": { ar: "ملاحظة", en: "Note" },
  "common.notePlaceholder": {
    ar: "مثلاً: بدون بصل (اختياري)",
    en: "For example: no onions (optional)",
  },
  "common.optional": { ar: "اختياري", en: "Optional" },
  "common.from": { ar: "من", en: "From" },
  "map.zoomIn": { ar: "تكبير الخريطة", en: "Zoom in" },
  "map.zoomOut": { ar: "تصغير الخريطة", en: "Zoom out" },

  "home.cta": { ar: "اطلب الآن", en: "Order Now" },
  "home.heroCarousel": { ar: "لافتات المطعم", en: "Restaurant banners" },
  "home.carouselRole": { ar: "عرض شرائح", en: "carousel" },
  "home.previousBanner": { ar: "اللافتة السابقة", en: "Previous banner" },
  "home.nextBanner": { ar: "اللافتة التالية", en: "Next banner" },
  "home.chooseBanner": { ar: "اختر لافتة", en: "Choose a banner" },
  "home.showBanner": {
    ar: "عرض اللافتة {current} من {total}",
    en: "Show banner {current} of {total}",
  },
  "home.pauseBanners": {
    ar: "إيقاف تبديل اللافتات",
    en: "Pause banner rotation",
  },
  "home.resumeBanners": {
    ar: "استئناف تبديل اللافتات",
    en: "Resume banner rotation",
  },
  "home.bannerStatus": {
    ar: "اللافتة {current} من {total}",
    en: "Banner {current} of {total}",
  },
  "home.quickTitle": {
    ar: "طلبك أو زيارتك القادمة",
    en: "Order in or visit us",
  },
  "home.menu": { ar: "اطلب وجبتك المفضلة", en: "Find your next meal" },
  "home.menuDesc": {
    ar: "اختر التوصيل أو الاستلام، ثم تصفح الأطباق المتاحة.",
    en: "Choose delivery or pickup, then explore the available dishes.",
  },
  "home.branches": { ar: "فروعنا", en: "Our Branches" },
  "home.branchesDesc": {
    ar: "اطّلع على العناوين ومواعيد العمل قبل زيارتك.",
    en: "Check locations and opening hours before your visit.",
  },
  "home.storyTitle": {
    ar: "من اختيار وجبتك إلى استلامها",
    en: "From your first choice to your first bite",
  },
  "home.storyBody": {
    ar: "اختر التوصيل أو الاستلام من الفرع، وأضف أطباقك المفضلة، ثم راجع التفاصيل وأكّد طلبك.",
    en: "Choose delivery or pickup, add your favourite dishes, then review the details and place your order.",
  },
  "home.stat2": { ar: "الفروع", en: "Branches" },

  "mainMenu.title": { ar: "ابدأ طلبك", en: "Start your order" },
  "mainMenu.subtitle": {
    ar: "هل تطلب للتوصيل أو الاستلام، أم تتصفح قائمة المطعم؟",
    en: "Ordering for delivery or pickup, or browsing the dine-in menu?",
  },
  "mainMenu.dinein": { ar: "تناول داخل المطعم", en: "Dine-in" },
  "mainMenu.dineinDesc": {
    ar: "تصفح أطباق الفرع وأسعارها داخل المطعم. للطلب، تواصل مع فريق الفرع.",
    en: "Explore dishes and dine-in prices at your branch. Order with the restaurant team.",
  },
  "mainMenu.online": { ar: "استلام أو توصيل", en: "Pickup or Delivery" },
  "mainMenu.onlineDesc": {
    ar: "اختر التوصيل إلى عنوانك أو الاستلام من الفرع، ثم ابدأ طلبك.",
    en: "Choose delivery to your address or pickup from a branch, then build your order.",
  },
  "mainMenu.unavailable": {
    ar: "القائمة غير متاحة حالياً",
    en: "Menu unavailable right now",
  },
  "mainMenu.unavailableDesc": {
    ar: "لا تتوفر حالياً قائمة للطلب أو لتناول الطعام داخل المطعم.",
    en: "Online ordering and dine-in browsing are not available at the moment.",
  },
  "branchMenu.selectTitle": { ar: "اختر الفرع", en: "Select your branch" },
  "branchMenu.selectDesc": {
    ar: "من فضلك اختر الفرع الذي تجلس فيه لعرض المنيو والأسعار.",
    en: "Pick the branch you're dining at to see its menu and prices.",
  },
  "branchMenu.readonly": {
    ar: "المنيو داخل المطعم للتصفح فقط",
    en: "Dine-in menu — browsing only",
  },
  "branchMenu.searchPlaceholder": {
    ar: "ابحث عن طبق…",
    en: "Search for a dish…",
  },
  "branchMenu.variations": { ar: "الأحجام والخيارات", en: "Sizes & options" },

  "menu.title": { ar: "المنيو", en: "Menu" },
  "menu.photoMissing": {
    ar: "لا توجد صورة للصنف: {name}",
    en: "No product photo for {name}",
  },
  "menu.selectOrderType": {
    ar: "اختر طريقة استلام طلبك",
    en: "Choose delivery or pickup",
  },
  "menu.orderTypeRequired": {
    ar: "اختر التوصيل أو الاستلام من الفرع لعرض الأصناف المتاحة لطلبك.",
    en: "Choose delivery or pickup to see what is available for your order.",
  },
  "menu.selectOrderContext": {
    ar: "اختر طريقة الطلب والفرع لمعرفة السعر الحالي والتوفر.",
    en: "Select an order type and branch to see the current price and availability.",
  },
  "menu.selectOrderContextAction": {
    ar: "اختيار طريقة الطلب والفرع",
    en: "Select order type and branch",
  },
  "menu.changeOrderContext": {
    ar: "تغيير الفرع أو طريقة الطلب",
    en: "Change branch or order type",
  },
  "menu.unavailableAtBranch": {
    ar: "هذا الصنف غير متاح من الفرع المحدد حاليًا. اختر صنفًا آخر أو حاول مرة أخرى لاحقًا.",
    en: "This item is not available from the selected branch right now. Choose another item or try again later.",
  },
  "menu.branchUnavailable": {
    ar: "الفرع مشغول ولا يستقبل طلبات الآن. اختر فرعًا آخر أو حاول مرة أخرى لاحقًا.",
    en: "This branch is busy and is not accepting orders right now. Choose another branch or try again later.",
  },
  "menu.orderTypeUnavailable": {
    ar: "هذا الصنف غير متاح لطريقة الطلب المحددة حاليًا. اختر طريقة أخرى أو حاول لاحقًا.",
    en: "This item is unavailable with the selected ordering option right now. Choose another option or try again later.",
  },
  "menu.delivery": { ar: "توصيل", en: "Delivery" },
  "menu.pickup": { ar: "استلام من الفرع", en: "Pickup" },
  "menu.categories": { ar: "الأقسام", en: "Categories" },
  "menu.searchCategories": { ar: "ابحث في الأقسام", en: "Search categories" },
  "menu.searchProducts": { ar: "ابحث عن طبق…", en: "Search for a dish…" },
  "menu.addToCart": { ar: "أضف إلى السلة", en: "Add to cart" },
  "menu.added": { ar: "أُضيف إلى السلة", en: "Added to cart" },
  "menu.similarItems": { ar: "أصناف مشابهة", en: "Similar items" },
  "menu.previousPrice": { ar: "السعر السابق", en: "Previous price" },
  "menu.currentPrice": { ar: "السعر الحالي", en: "Current price" },
  "menu.discountBadge": { ar: "خصم {percent}٪", en: "{percent}% off" },
  "menu.similarPrevious": { ar: "الأصناف السابقة", en: "Previous items" },
  "menu.similarNext": { ar: "الأصناف التالية", en: "Next items" },
  "menu.additions": { ar: "الإضافات", en: "Add-ons" },
  "menu.viewVariations": { ar: "اختر الحجم والإضافات", en: "Choose options" },
  "menu.chooseVariation": { ar: "اختر النوع", en: "Choose an option" },
  "menu.emptyCategory": {
    ar: "لا توجد أطباق متاحة في هذا القسم حالياً.",
    en: "No dishes are available in this category right now.",
  },
  "menu.noResults": {
    ar: "لا توجد نتائج مطابقة لبحثك.",
    en: "No dishes match your search.",
  },
  "menu.unavailable": {
    ar: "هذا الصنف غير متاح من هذا الفرع حاليًا",
    en: "This item is unavailable from this branch right now",
  },

  "cart.title": { ar: "سلة الطلب", en: "Your cart" },
  "cart.empty": { ar: "سلتك فارغة", en: "Your cart is empty" },
  "cart.emptyDesc": {
    ar: "أضف أطباقك المفضلة لتبدأ الطلب.",
    en: "Add your favourite dishes to get started.",
  },
  "cart.unfinishedTitle": {
    ar: "أصناف طلب الدفع السابق محفوظة",
    en: "Your previous checkout items are saved",
  },
  "cart.unfinishedChecking": {
    ar: "نتحقق من حالة الدفع السابق قبل استعادة الأصناف.",
    en: "We're checking the earlier payment before restoring these items.",
  },
  "cart.unfinishedPending": {
    ar: "قد يكتمل الدفع السابق لاحقًا. استعادة الأصناف تبدأ طلبًا جديدًا ولا تلغي الدفع السابق. تحقق من حالته قبل إتمام طلب آخر.",
    en: "The earlier payment may still complete. Restoring these items starts a new order and does not cancel that payment. Check its status before placing another order.",
  },
  "cart.unfinishedFailed": {
    ar: "لم يكتمل الدفع السابق. يمكنك استعادة الأصناف لتعديل طلبك ثم المحاولة مجددًا.",
    en: "The earlier payment did not complete. Restore the items to change your order and try again.",
  },
  "cart.unfinishedError": {
    ar: "تعذّر التحقق من حالة الدفع السابق. أعد المحاولة قبل استعادة الأصناف.",
    en: "We couldn't check the earlier payment. Try again before restoring the items.",
  },
  "cart.unfinishedRestore": { ar: "استعادة الأصناف", en: "Restore items" },
  "cart.unfinishedViewOrder": {
    ar: "عرض الطلب السابق",
    en: "View earlier order",
  },
  "cart.unfinishedReplaceTitle": {
    ar: "استبدال السلة الحالية؟",
    en: "Replace the current cart?",
  },
  "cart.unfinishedReplaceDescription": {
    ar: "الأصناف المحفوظة لفرع أو طريقة استلام مختلفة. ستستبدل استعادتها الأصناف الموجودة حاليًا في سلتك.",
    en: "The saved items are for a different branch or order type. Restoring them will replace the items currently in your cart.",
  },
  "cart.unfinishedReplaceAction": {
    ar: "استبدال السلة واستعادة الأصناف",
    en: "Replace and restore items",
  },
  "cart.browse": { ar: "تصفح المنيو", en: "Browse the menu" },
  "cart.subtotal": { ar: "إجمالي الأصناف", en: "Items subtotal" },
  "cart.deliveryFee": { ar: "رسوم التوصيل", en: "Delivery fee" },
  "cart.serviceFee": { ar: "رسوم الخدمة", en: "Service fee" },
  "cart.discount": { ar: "الخصم", en: "Discount" },
  "cart.total": { ar: "الإجمالي", en: "Total" },
  "cart.tax": { ar: "الضريبة", en: "Tax" },
  "orders.taxIncluded": { ar: "الضريبة (مشمولة)", en: "Tax (included)" },
  "cart.calculating": { ar: "جارٍ حساب الإجمالي…", en: "Calculating total…" },
  "cart.pleaseWait": { ar: "يرجى الانتظار…", en: "Please wait…" },
  "cart.promotionPlaceholder": { ar: "أدخل كود العرض", en: "Enter offer code" },
  "cart.applyPromotion": { ar: "تطبيق", en: "Apply" },
  "cart.promotionLabel": { ar: "هل لديك كود عرض؟", en: "Have an offer code?" },
  "cart.linkedOffer": { ar: "عرض مضاف من الرابط", en: "Linked offer" },
  "cart.linkedOfferAutomatic": {
    ar: "سيتم تطبيق العرض تلقائيًا عند حساب الإجمالي.",
    en: "The offer is applied automatically when your total is calculated.",
  },
  "cart.removeLinkedOffer": {
    ar: "إزالة العرض",
    en: "Remove linked offer",
  },
  "cart.linkedOfferUnavailable": {
    ar: "لم يعد هذا العرض متاحًا. يمكنك متابعة الطلب بدونه.",
    en: "This offer is no longer available. You can continue without it.",
  },
  "cart.promotionUnavailable": {
    ar: "هذا العرض غير متاح حالياً. حدّث السلة أو حاول مرة أخرى لاحقاً.",
    en: "This offer is not available right now. Refresh your cart or try again later.",
  },
  "cart.promotionInvalid": {
    ar: "كود العرض غير صحيح. تحقق من الكود وحاول مرة أخرى.",
    en: "This offer code is invalid. Check the code and try again.",
  },
  "cart.promotionExpired": {
    ar: "انتهت صلاحية كود العرض هذا.",
    en: "This offer code has expired.",
  },
  "cart.promotionIneligible": {
    ar: "هذا العرض لا ينطبق على طلبك الحالي. راجع شروط العرض.",
    en: "This offer does not apply to your current order. Review the offer terms.",
  },
  "cart.previewDisabled": {
    ar: "إتمام الطلب معطل في المعاينة",
    en: "Checkout is disabled in preview",
  },
  "cart.checkoutUnavailable": {
    ar: "تعذّر تحديث الإجمالي",
    en: "Could not update the total",
  },
  "cart.checkout": { ar: "المتابعة لإتمام الطلب", en: "Continue to checkout" },
  "cart.suggestionsTitle": {
    ar: "هل نسيت شيئًا؟",
    en: "Anything else for your order?",
  },
  "cart.suggestionsDescription": {
    ar: "أضف صنفًا الآن أو تابع لإتمام طلبك.",
    en: "Add an item now, or continue to checkout.",
  },
  "cart.suggestionsAdded": {
    ar: "أُضيفت الأصناف المختارة إلى سلتك.",
    en: "Your selected items are in the cart.",
  },
  "cart.suggestionsAdd": { ar: "أضف", en: "Add" },
  "cart.suggestionsCustomize": { ar: "اختر الخيارات", en: "Choose options" },
  "cart.suggestionsContinue": {
    ar: "لا شكرًا، تابع لإتمام الطلب",
    en: "No thanks, continue to checkout",
  },
  "cart.remove": { ar: "حذف", en: "Remove" },
  "cart.line": { ar: "{count} صنف", en: "{count} item" },
  "cart.lines": { ar: "{count} أصناف", en: "{count} items" },
  "cart.clearAction": { ar: "إفراغ السلة", en: "Clear cart" },
  "cart.continueShopping": {
    ar: "أضف المزيد من الأطباق",
    en: "Add more dishes",
  },
  "cart.clearTitle": { ar: "هل تريد إفراغ السلة؟", en: "Clear your cart?" },
  "cart.clearDesc": {
    ar: "سيتم حذف جميع الأصناف الموجودة في سلتك الحالية.",
    en: "All items in your current cart will be removed.",
  },
  "cart.clearConfirm": {
    ar: "إفراغ السلة والمتابعة",
    en: "Clear cart & continue",
  },
  "cart.branchChangeTitle": {
    ar: "تغيير الفرع سيفرغ السلة",
    en: "Changing branch clears your cart",
  },
  "cart.branchChangeDesc": {
    ar: "توافر الأصناف والأسعار مرتبط بالفرع. للمتابعة سيتم إفراغ سلتك الحالية.",
    en: "Availability and prices depend on the branch. Continuing will empty your current cart.",
  },

  "orderType.title": {
    ar: "كيف تريد استلام طلبك؟",
    en: "How would you like your order?",
  },
  "orderType.deliveryDesc": {
    ar: "أوصل طلبك إلى عنوانك",
    en: "Deliver to your address",
  },
  "orderType.pickupDesc": {
    ar: "استلم طلبك من الفرع",
    en: "Collect from a branch",
  },
  "orderType.deliveryUnavailable": {
    ar: "التوصيل غير متاح للطلبات الآن",
    en: "Delivery is unavailable right now",
  },
  "orderType.pickupUnavailable": {
    ar: "الاستلام غير متاح للطلبات الآن",
    en: "Pickup is unavailable right now",
  },
  "orderType.chooseMethodFirst": {
    ar: "اختر التوصيل أو الاستلام للمتابعة.",
    en: "Choose delivery or pickup to continue.",
  },
  "orderType.choosePickup": {
    ar: "اختيار الاستلام بدلًا من ذلك",
    en: "Choose pickup instead",
  },
  "orderType.useMyLocation": {
    ar: "استخدم موقعي الحالي",
    en: "Use my current location",
  },
  "orderType.locationUnavailable": {
    ar: "تعذر تحديد موقعك. حرّك الخريطة لتحديده يدوياً.",
    en: "Your location could not be found. Drag the map to choose it manually.",
  },
  "orderType.zoneAvailable": {
    ar: "التوصيل متاح لهذا الموقع",
    en: "We deliver to this location",
  },
  "orderType.zoneUnavailable": {
    ar: "التوصيل غير متاح لهذا العنوان حاليًا. جرّب عنوانًا آخر أو اختر الاستلام من الفرع.",
    en: "Delivery is not available for this address right now. Try another address or choose pickup.",
  },
  "orderType.assignedBranch": { ar: "الفرع", en: "Branch" },
  "orderType.minimumOrder": { ar: "الحد الأدنى للطلب", en: "Minimum order" },
  "orderType.freeDeliveryAt": {
    ar: "توصيل مجاني ابتداءً من",
    en: "Free delivery from",
  },
  "orderType.estimatedDelivery": {
    ar: "وقت التوصيل المتوقع",
    en: "Estimated delivery",
  },
  "orderType.minutes": { ar: "{count} دقيقة", en: "{count} min" },
  "orderType.distance": { ar: "المسافة التقريبية", en: "Approx. distance" },
  "orderType.pageDesc": {
    ar: "حدد موقع التوصيل أو فرع الاستلام لعرض المنيو المتاحة لك.",
    en: "Choose a delivery location or pickup branch to see your available menu.",
  },
  "orderType.deliveryDetails": { ar: "عنوان التوصيل", en: "Delivery address" },
  "orderType.deliveryLocation": {
    ar: "حدد موقع التوصيل",
    en: "Choose delivery location",
  },
  "orderType.pickupDetails": { ar: "بيانات الاستلام", en: "Pickup details" },
  "orderType.selectBranch": { ar: "اختر الفرع", en: "Choose a branch" },
  "orderType.deliverySummary": { ar: "ملخص التوصيل", en: "Delivery summary" },
  "orderType.pickupSummary": { ar: "ملخص الاستلام", en: "Pickup summary" },
  "orderType.savedAddresses": {
    ar: "العناوين المحفوظة",
    en: "Saved addresses",
  },
  "orderType.newAddress": {
    ar: "اختر موقعاً آخر",
    en: "Choose another location",
  },
  "orderType.fullName": { ar: "الاسم بالكامل", en: "Full name" },
  "orderType.phone": { ar: "رقم الهاتف", en: "Phone number" },
  "orderType.street": { ar: "الشارع", en: "Street" },
  "orderType.area": { ar: "المنطقة", en: "Area" },
  "orderType.building": { ar: "رقم العمارة", en: "Building number" },
  "orderType.floor": { ar: "الدور", en: "Floor" },
  "orderType.apartment": { ar: "الشقة", en: "Apartment" },
  "orderType.landmark": { ar: "علامة مميزة", en: "Landmark" },
  "orderType.addressNote": {
    ar: "تعليمات التوصيل (اختياري)",
    en: "Delivery instructions (optional)",
  },
  "orderType.recipient": { ar: "اسم المستلم", en: "Recipient name" },
  "orderType.pickupTime": { ar: "موعد الاستلام", en: "Pickup time" },
  "orderType.asap": { ar: "في أقرب وقت", en: "As soon as possible" },
  "orderType.scheduled": { ar: "تحديد موعد", en: "Schedule" },
  "orderType.pickupHint": {
    ar: "اختر موعداً خلال الأيام السبعة القادمة ضمن ساعات عمل الفرع.",
    en: "Choose a time within the next 7 days when this branch is open.",
  },
  "orderType.pickupCheckoutHint": {
    ar: "ستضيف اسم المستلم وموعد الاستلام عند إتمام الطلب.",
    en: "You'll add the recipient and pickup time during checkout.",
  },
  "orderType.branchClosed": {
    ar: "الفرع مغلق حالياً",
    en: "Branch is closed now",
  },
  "orderType.confirm": {
    ar: "المتابعة إلى المنيو",
    en: "Continue to menu",
  },
  "orderType.invalidPhone": {
    ar: "أدخل رقم هاتف صحيحاً.",
    en: "Enter a valid phone number.",
  },
  "orderType.nameRequired": {
    ar: "أدخل اسماً مكوّناً من حرفين على الأقل.",
    en: "Enter a name with at least 2 characters.",
  },
  "orderType.streetRequired": {
    ar: "أدخل اسم الشارع.",
    en: "Enter the street name.",
  },
  "orderType.buildingRequired": {
    ar: "أدخل رقم المبنى.",
    en: "Enter the building number.",
  },
  "orderType.floorRequired": {
    ar: "أدخل رقم الدور.",
    en: "Enter the floor number.",
  },
  "orderType.apartmentRequired": {
    ar: "أدخل رقم الشقة.",
    en: "Enter the apartment number.",
  },
  "orderType.optionalAddressDetails": {
    ar: "إضافة تفاصيل أخرى للعنوان (اختياري)",
    en: "Add more address details (optional)",
  },
  "orderType.required": {
    ar: "من فضلك أكمل الحقول المطلوبة.",
    en: "Please complete the required fields.",
  },
  "orderType.unavailable": {
    ar: "لا توجد طريقة طلب متاحة حالياً.",
    en: "No ordering method is available right now.",
  },
  "orderType.paused": {
    ar: "متوقف مؤقتًا من المطعم",
    en: "Temporarily paused by the restaurant",
  },
  "orderType.pausedHelp": {
    ar: "أوقف المطعم استقبال الطلبات الجديدة مؤقتًا. أعد المحاولة لمعرفة ما إذا استؤنف الاستقبال.",
    en: "The restaurant has temporarily paused new orders. Retry to check whether ordering has resumed.",
  },

  "checkout.title": { ar: "إتمام الطلب", en: "Checkout" },
  "checkout.subtitle": {
    ar: "أكمل بيانات الاستلام واختر طريقة الدفع، ثم أكّد طلبك.",
    en: "Add your details, choose how to pay, then place your order.",
  },
  "checkout.backToMenu": { ar: "العودة للمنيو", en: "Back to menu" },
  "checkout.items": { ar: "أصناف الطلب", en: "Order items" },
  "checkout.details": { ar: "بيانات الطلب", en: "Order details" },
  "checkout.fulfillment": {
    ar: "طريقة استلام الطلب",
    en: "Delivery or pickup",
  },
  "checkout.changeType": {
    ar: "تغيير النوع أو الفرع",
    en: "Change type or branch",
  },
  "checkout.verifiedPhone": {
    ar: "رقم الهاتف موثّق",
    en: "Phone number verified",
  },
  "checkout.deliveryPoint": {
    ar: "موقع التوصيل محدد",
    en: "Delivery point selected",
  },
  "checkout.deliveryPointDescription": {
    ar: "أضف اسم الشارع ورقم المبنى بالأسفل. لتغيير الموقع، اضغط «تغيير».",
    en: "Add your street and building number below. Select Change to move the delivery location.",
  },
  "checkout.verifyTitle": {
    ar: "سجّل الدخول لإتمام طلبك",
    en: "Sign in to complete your order",
  },
  "checkout.verifyDescription": {
    ar: "تحقق من رقم هاتفك للمتابعة. إذا كانت هذه زيارتك الأولى، سنطلب اسمك بعد التحقق. سلتك محفوظة.",
    en: "Verify your phone to continue. If you're new, we'll ask for your name afterward. Your cart is saved.",
  },
  "checkout.verifyAction": {
    ar: "المتابعة برقم الهاتف",
    en: "Continue with phone number",
  },
  "checkout.verifyCartReady": {
    ar: "أصنافك محفوظة في السلة",
    en: "Your items are saved in your cart",
  },
  "checkout.payment": { ar: "طريقة الدفع", en: "Payment method" },
  "checkout.paymentHint": {
    ar: "اختر الطريقة المناسبة لإتمام الدفع.",
    en: "Choose how you would like to pay for this order.",
  },
  "checkout.cash": { ar: "نقداً عند التوصيل", en: "Cash on delivery" },
  "checkout.cashPickup": {
    ar: "نقداً عند الاستلام من الفرع",
    en: "Cash at pickup",
  },
  "checkout.cashDescription": {
    ar: "ادفع للمطعم عند استلام الطلب.",
    en: "Pay the restaurant when you receive your order.",
  },
  "checkout.onlineCard": {
    ar: "الدفع بالبطاقة عبر الإنترنت",
    en: "Pay online by card",
  },
  "checkout.onlineCardDescription": {
    ar: "ستنتقل إلى صفحة دفع آمنة لإتمام الدفع.",
    en: "You'll continue to a secure payment page to complete payment.",
  },
  "checkout.continueOnline": {
    ar: "المتابعة للدفع الآمن",
    en: "Continue to secure payment",
  },
  "checkout.redirectTitle": {
    ar: "جارٍ تحويلك إلى صفحة الدفع",
    en: "Taking you to the payment page",
  },
  "checkout.redirectDescription": {
    ar: "يرجى الانتظار بينما نفتح صفحة الدفع الآمنة. إذا لم تُفتح تلقائيًا، اضغط على زر المتابعة أدناه.",
    en: "Please wait while we open the secure payment page. If it doesn't open automatically, use the button below.",
  },
  "checkout.returnToCart": { ar: "العودة إلى السلة", en: "Return to cart" },
  "checkout.savedCartTitle": {
    ar: "تحقق من طلب الدفع السابق",
    en: "Check your previous checkout",
  },
  "checkout.savedCartDescription": {
    ar: "حفظنا أصنافك أثناء التحقق من الدفع. افتح السلة لمعرفة ما إذا كان يمكنك استعادتها.",
    en: "Your items were saved while payment is being checked. Open the cart to see whether you can restore them.",
  },
  "checkout.summary": { ar: "ملخص الطلب", en: "Order summary" },
  "checkout.notes": { ar: "ملاحظات الطلب", en: "Order notes" },
  "checkout.addNotes": {
    ar: "إضافة ملاحظة للمطعم (اختياري)",
    en: "Add a note for the restaurant (optional)",
  },
  "checkout.notesHint": {
    ar: "أضف أي تعليمات يحتاج المطعم إلى معرفتها (اختياري).",
    en: "Add anything the restaurant should know (optional).",
  },
  "checkout.confirmCash": { ar: "تأكيد الطلب", en: "Confirm order" },
  "checkout.legal": {
    ar: "بالمتابعة أنت توافق على",
    en: "By continuing you agree to our",
  },
  "checkout.changeDetails": {
    ar: "تعديل بيانات الطلب",
    en: "Change order details",
  },
  "checkout.noPaymentMethods": {
    ar: "لا توجد طريقة دفع متاحة لهذا الطلب.",
    en: "No payment method is available for this order.",
  },
  "checkout.accountUnavailable": {
    ar: "الطلب الإلكتروني غير متاح حالياً. تواصل مع أحد الفروع للمساعدة.",
    en: "Online ordering is currently unavailable. Contact a branch for help.",
  },

  "success.title": { ar: "تم استلام طلبك", en: "Your order has been received" },
  "success.confirmed": {
    ar: "تم تأكيد إرسال الطلب",
    en: "Order placed successfully",
  },
  "success.desc": {
    ar: "شكراً لطلبك. يمكنك متابعة حالته من صفحة الطلب.",
    en: "Thank you for ordering. You can follow its status on the order page.",
  },
  "success.orderNumber": { ar: "رقم الطلب", en: "Order number" },
  "success.account": { ar: "الذهاب لحسابي", en: "Go to My Account" },
  "success.loadingTitle": {
    ar: "جارٍ تجهيز تأكيد طلبك",
    en: "Preparing your order confirmation",
  },
  "success.loadingDescription": {
    ar: "نسترجع تفاصيل الطلب الآن. لن يستغرق ذلك سوى لحظة.",
    en: "We're loading the order details. This should only take a moment.",
  },
  "success.promotionSaved": { ar: "وفّرت", en: "You saved" },
  "success.restaurant": { ar: "المطعم", en: "Restaurant" },
  "success.branch": { ar: "الفرع", en: "Branch" },
  "success.branchPending": {
    ar: "سيظهر في تفاصيل الطلب",
    en: "Shown in order details",
  },
  "success.orderType": { ar: "طريقة الاستلام", en: "Order type" },
  "success.payment": { ar: "الدفع", en: "Payment" },
  "success.cashDelivery": { ar: "نقداً عند التوصيل", en: "Cash on delivery" },
  "success.cashPickup": { ar: "نقداً عند الاستلام", en: "Cash at pickup" },
  "success.onlinePaid": { ar: "مدفوع إلكترونياً", en: "Paid online" },
  "success.trackOrder": { ar: "متابعة الطلب", en: "Track order" },
  "success.callRestaurant": { ar: "الاتصال بالمطعم", en: "Call restaurant" },

  "paymentReturn.previewTitle": {
    ar: "الدفع غير متاح في المعاينة",
    en: "Payment is unavailable in preview",
  },
  "paymentReturn.previewBody": {
    ar: "انشر المتجر أولاً لاختبار رحلة دفع حقيقية.",
    en: "Publish the storefront before testing a real payment journey.",
  },
  "paymentReturn.missingTitle": {
    ar: "تعذّر العثور على عملية الدفع",
    en: "We couldn't find this payment",
  },
  "paymentReturn.missingBody": {
    ar: "افتح طلباتك للتحقق من أحدث حالة دفع بأمان.",
    en: "Open your orders to check the latest payment status safely.",
  },
  "paymentReturn.signInTitle": {
    ar: "سجّل الدخول للتحقق من الدفع",
    en: "Sign in to check your payment",
  },
  "paymentReturn.signInBody": {
    ar: "يجب استخدام الحساب الذي أنشأ الطلب.",
    en: "Use the same account that placed the order.",
  },
  "paymentReturn.checkingTitle": {
    ar: "جارٍ التحقق من الدفع",
    en: "Checking your payment",
  },
  "paymentReturn.checkingBody": {
    ar: "ننتظر تأكيداً آمناً من مزود الدفع. لا تغلق هذه الصفحة.",
    en: "We're waiting for secure confirmation from the payment provider. Keep this page open.",
  },
  "paymentReturn.delayedTitle": {
    ar: "يحتاج تأكيد الدفع إلى وقت أطول",
    en: "Payment confirmation is taking longer",
  },
  "paymentReturn.delayedBody": {
    ar: "لا تحاول الدفع مرة أخرى الآن. سنستمر في التحقق لتجنب خصم المبلغ مرتين.",
    en: "Do not pay again yet. We'll keep checking to avoid charging you twice.",
  },
  "paymentReturn.errorTitle": {
    ar: "تعذّر التحقق من الدفع",
    en: "We couldn't check the payment",
  },
  "paymentReturn.errorBody": {
    ar: "تحقق من اتصالك ثم حاول مرة أخرى. لن يؤدي ذلك إلى خصم جديد.",
    en: "Check your connection and try again. This will not create another charge.",
  },
  "paymentReturn.failedTitle": {
    ar: "لم تكتمل عملية الدفع",
    en: "Payment was not completed",
  },
  "paymentReturn.failedBody": {
    ar: "يمكنك بدء محاولة دفع جديدة وآمنة لنفس الطلب.",
    en: "You can start a new secure payment attempt for the same order.",
  },
  "paymentReturn.retryPayment": {
    ar: "إعادة محاولة الدفع",
    en: "Try payment again",
  },
  "paymentReturn.viewOrder": { ar: "عرض الطلب", en: "View order" },
  "paymentReturn.actionTitle": {
    ar: "أكمل الدفع الآمن",
    en: "Complete secure payment",
  },
  "paymentReturn.actionBody": {
    ar: "عملية الدفع جاهزة للمتابعة لدى فوري.",
    en: "Your payment is ready to continue with Fawry.",
  },
  "paymentReturn.continuePayment": {
    ar: "المتابعة إلى فوري",
    en: "Continue to Fawry",
  },
  "paymentReturn.checkAgain": { ar: "التحقق مرة أخرى", en: "Check again" },

  "login.title": { ar: "المتابعة برقم الهاتف", en: "Continue with phone" },
  "login.phoneStep": {
    ar: "أدخل رقم هاتفك وسنرسل إليك رمز التحقق.",
    en: "Enter your phone number and we'll text you a verification code.",
  },
  "login.nameStep": {
    ar: "تم التحقق من رقمك. أخبرنا باسمك لإكمال حسابك.",
    en: "Your phone is verified. Tell us your name to finish setting up your account.",
  },
  "login.complete": { ar: "المتابعة", en: "Continue" },
  "login.changePhone": { ar: "تغيير رقم الهاتف", en: "Change phone number" },
  "login.registrationExpired": {
    ar: "انتهت صلاحية التحقق. ارجع واطلب رمزًا جديدًا.",
    en: "Verification expired. Go back and request a new code.",
  },
  "login.phonePlaceholder": { ar: "رقم الهاتف", en: "Phone number" },
  "login.send": { ar: "إرسال رمز التحقق", en: "Send verification code" },
  "login.otpStep": {
    ar: "أدخل الكود المكوّن من ٤ أرقام المرسل إلى {phone}.",
    en: "Enter the 4-digit code sent to {phone}.",
  },
  "login.otpCode": { ar: "رمز التحقق", en: "Verification code" },
  "login.verify": { ar: "تأكيد", en: "Verify" },
  "login.resend": { ar: "إعادة الإرسال", en: "Resend code" },
  "login.invalidOtp": {
    ar: "الكود غير صحيح، حاول مرة أخرى.",
    en: "That code isn't correct. Try again.",
  },
  "login.attemptsExhausted": {
    ar: "تم تجاوز عدد المحاولات. اطلب رمزًا جديدًا للمحاولة مرة أخرى.",
    en: "Too many attempts. Request a new code to try again.",
  },
  "login.resendCooldown": {
    ar: "انتظر قليلاً قبل طلب كود جديد.",
    en: "Please wait before requesting another code.",
  },
  "login.rateLimited": {
    ar: "تم طلب أكواد كثيرة. حاول مرة أخرى بعد قليل.",
    en: "Too many codes were requested. Please try again later.",
  },
  "login.smsUnavailable": {
    ar: "تعذر إرسال كود التحقق الآن. حاول مرة أخرى بعد قليل.",
    en: "We couldn't send the verification code. Please try again shortly.",
  },
  "account.title": { ar: "حسابي", en: "My account" },
  "account.verified": { ar: "موثّق", en: "Verified" },
  "account.unverified": { ar: "غير موثّق", en: "Unverified" },
  "account.addAddress": { ar: "إضافة عنوان", en: "Add address" },
  "account.editAddress": { ar: "تعديل العنوان", en: "Edit address" },
  "account.viewOrders": { ar: "كل الطلبات", en: "View all orders" },
  "account.recentOrders": { ar: "أحدث الطلبات", en: "Recent orders" },
  "account.addresses": { ar: "العناوين المحفوظة", en: "Saved addresses" },
  "account.noAddresses": {
    ar: "لم تضف عنواناً بعد.",
    en: "You haven't added an address yet.",
  },
  "account.openMaps": { ar: "فتح في الخرائط", en: "Open in Google Maps" },
  "account.edit": { ar: "تعديل", en: "Edit" },
  "account.name": { ar: "الاسم", en: "Name" },
  "account.deleteAddress": { ar: "حذف العنوان", en: "Delete address" },
  "account.deleteAddressDescription": {
    ar: "سيتم حذف هذا العنوان المحفوظ نهائياً.",
    en: "This saved address will be permanently deleted.",
  },

  "orders.title": { ar: "طلباتي", en: "My orders" },
  "orders.empty": { ar: "لا توجد طلبات بعد", en: "No orders yet" },
  "orders.emptyDesc": {
    ar: "ابدأ أول طلب من القائمة.",
    en: "Place your first order from the menu.",
  },
  "orders.view": { ar: "تفاصيل الطلب", en: "View details" },
  "orders.status.pending": { ar: "قيد الانتظار", en: "Pending" },
  "orders.cancellation": { ar: "إلغاء الطلب", en: "Order cancellation" },
  "orders.cancelOrder": { ar: "إلغاء الطلب", en: "Cancel order" },
  "orders.canceling": { ar: "جارٍ الإلغاء…", en: "Canceling…" },
  "orders.cancellationPending": {
    ar: "يمكنك إلغاء الطلب ما دام قيد الانتظار ولم يقبله المطعم بعد.",
    en: "You can cancel while the order is pending, before the restaurant accepts it.",
  },
  "orders.cancellationAccepted": {
    ar: "قبل المطعم الطلب بالفعل، ولا يمكن إلغاؤه عبر المنصة. يرجى التواصل مع المطعم مباشرةً إذا كنت ترغب في طلب الإلغاء.",
    en: "The order has already been accepted and can no longer be canceled online. Contact the restaurant directly if you still want to request cancellation.",
  },
  "orders.cancellationClosed": {
    ar: "لم يعد الطلب قيد الانتظار ولا يمكن إلغاؤه عبر المنصة. يرجى التواصل مع المطعم مباشرةً للمساعدة.",
    en: "This order is no longer pending and cannot be canceled online. Contact the restaurant directly for help.",
  },
  "orders.cancelConfirmation": {
    ar: "هل تريد إلغاء هذا الطلب؟ لا يمكن التراجع عن الإلغاء. إذا كنت قد دفعت، تواصل مع المطعم لترتيب استرداد المبلغ.",
    en: "Cancel this order? This cannot be undone. If you have already paid, contact the restaurant to arrange a refund.",
  },
  "orders.confirmCancellation": {
    ar: "نعم، إلغاء الطلب",
    en: "Yes, cancel order",
  },
  "orders.contactRestaurant": {
    ar: "الاتصال بالمطعم",
    en: "Contact restaurant",
  },
  "orders.cancellationError": {
    ar: "تعذر إلغاء الطلب. يرجى المحاولة مجددًا.",
    en: "Could not cancel the order. Please try again.",
  },
  "orders.status.accepted": {
    ar: "أكّد المطعم طلبك",
    en: "Confirmed by restaurant",
  },
  "orders.status.completed": { ar: "مكتمل", en: "Completed" },
  "orders.status.cancelled": { ar: "ملغي", en: "Cancelled" },
  "orders.created": { ar: "تاريخ الطلب", en: "Order placed" },
  "orders.cancelReason": { ar: "سبب الإلغاء", en: "Cancellation reason" },
  "orders.itemsTitle": { ar: "الأصناف المطلوبة", en: "Ordered items" },
  "orders.saved": { ar: "وفّرت", en: "Saved" },

  "branches.title": { ar: "فروعنا", en: "Our branches" },
  "branches.desc": {
    ar: "اعثر على الفرع الأنسب لك وتحقق من مواعيد العمل والخدمات.",
    en: "Find the right branch and check its hours and available services.",
  },
  "branches.search": {
    ar: "ابحث بالاسم أو العنوان…",
    en: "Search by name or address…",
  },
  "branches.openNow": { ar: "متاح الان", en: "Open now" },
  "branches.closedNow": { ar: "مغلق الآن", en: "Closed now" },
  "ordering.unavailable": { ar: "الطلب غير متاح حاليًا", en: "Ordering is not available" },
  "ordering.tryLater": { ar: "يرجى المحاولة مرة أخرى لاحقًا.", en: "Please try again later." },
  "branches.count": { ar: "{count} فرع", en: "{count} branches" },
  "branches.call": { ar: "اتصل", en: "Call" },
  "branches.maps": { ar: "الخرائط", en: "Maps" },
  "branches.tour": { ar: "جولة بالفيديو", en: "Video tour" },
  "branches.noResults": {
    ar: "لا توجد فروع مطابقة",
    en: "No matching branches",
  },

  "legal.terms": { ar: "الشروط والأحكام", en: "Terms & Conditions" },
  "legal.privacy": { ar: "سياسة الخصوصية", en: "Privacy Policy" },
  "legal.returns": { ar: "سياسة الاسترجاع", en: "Return Policy" },

  "notfound.title": { ar: "الصفحة غير موجودة", en: "Page not found" },
  "notfound.desc": {
    ar: "ربما تغيّر الرابط أو حُذفت الصفحة.",
    en: "The link may have changed or the page was removed.",
  },
  "notfound.home": { ar: "الرئيسية", en: "Home" },
  "notfound.menu": { ar: "المنيو", en: "Menu" },
  "error.title": { ar: "تعذّر تحميل الصفحة", en: "This page didn't load" },
  "error.desc": {
    ar: "حدث خطأ غير متوقع. حاول مرة أخرى أو ارجع إلى الصفحة الرئيسية.",
    en: "Something went wrong. Try again or head back home.",
  },
  "error.home": { ar: "العودة للرئيسية", en: "Go home" },

  "nav.legal": { ar: "السياسات والشروط", en: "Policies and terms" },
  "orderType.mapControlHint": {
    ar: "حرّك الخريطة لتحديد موقع الدبوس",
    en: "Move the map to position the pin",
  },
  "orderType.method": { ar: "طريقة الاستلام", en: "Order method" },
  "nav.main": { ar: "التنقل الرئيسي", en: "Main navigation" },
  "nav.breadcrumb": { ar: "مسار الصفحة", en: "Breadcrumb" },
  "common.saved": { ar: "تم حفظ التغييرات", en: "Changes saved" },
  "common.saving": { ar: "جارٍ الحفظ…", en: "Saving…" },
  "common.required": { ar: "مطلوب", en: "Required" },
  "common.increaseQuantity": { ar: "زيادة الكمية", en: "Increase quantity" },
  "common.decreaseQuantity": { ar: "تقليل الكمية", en: "Decrease quantity" },
  "home.resume": { ar: "تابع طلبك", en: "Continue your order" },
  "home.choose": { ar: "اختر طريقة الاستلام", en: "Choose how to order" },
  "home.chooseHint": {
    ar: "التوصيل أو الاستلام من الفرع",
    en: "Delivery or pickup",
  },
  "home.pick": { ar: "اختر أطباقك", en: "Pick your favourites" },
  "home.pickHint": {
    ar: "الأحجام والإضافات كما تحب",
    en: "Sizes and extras, your way",
  },
  "home.review": { ar: "راجع طلبك وأكّده", en: "Review and place your order" },
  "home.reviewHint": {
    ar: "بياناتك وطريقة الدفع في خطوة واحدة",
    en: "Your details and payment in one place",
  },
  "menu.subtitle": {
    ar: "اختر أطباقك وأضفها إلى السلة.",
    en: "Find your favourites and make them yours.",
  },
  "menu.clearSearch": { ar: "مسح البحث", en: "Clear search" },
  "menu.results": { ar: "نتائج البحث عن «{term}»", en: "Results for “{term}”" },
  "menu.resultsCount": {
    ar: "المعروض {shown} من {total}",
    en: "Showing {shown} of {total}",
  },
  "menu.noResultsHint": {
    ar: "جرّب اسم طبق آخر أو امسح البحث لتصفح القائمة.",
    en: "Try a different dish name or clear your search to browse the menu.",
  },
  "menu.noCategories": {
    ar: "المنيو غير متاحة حالياً",
    en: "The menu is unavailable right now",
  },
  "menu.noCategoriesHint": {
    ar: "جرّب فرعاً آخر أو أعد المحاولة لاحقاً.",
    en: "Try another branch or check back later.",
  },
  "menu.included": { ar: "ضمن السعر", en: "Included" },
  "menu.customize": { ar: "إضافات وملاحظات", en: "Extras and notes" },
  "menu.tooManyOptions": {
    ar: "قلّل عدد الإضافات ليتوافق مع الحد الأقصى للمجموعة.",
    en: "Choose fewer options to stay within the group limit.",
  },
  "menu.chooseUpTo": {
    ar: "اختياري · حتى {count}",
    en: "Optional · up to {count}",
  },
  "menu.chooseExactly": {
    ar: "مطلوب · اختر {count}",
    en: "Required · choose {count}",
  },
  "menu.chooseRange": {
    ar: "مطلوب · اختر من {minimum} إلى {maximum}",
    en: "Required · choose {minimum}–{maximum}",
  },
  "menu.requiredSelectionMissing": {
    ar: "اختر {count} على الأقل من هذه المجموعة.",
    en: "Choose at least {count} from this group.",
  },
  "menu.requiredOptionsMissing": {
    ar: "أكمل اختيارات الإضافات المطلوبة.",
    en: "Complete the required option selections.",
  },
  "menu.optionsHint": {
    ar: "اختر الحجم والإضافات المناسبة لك.",
    en: "Choose your preferred size and extras.",
  },
  "cart.view": { ar: "عرض السلة", en: "View cart" },
  "cart.details": { ar: "الإضافات والملاحظات", en: "Extras and notes" },
  "cart.removeItem": {
    ar: "حذف {name} من السلة",
    en: "Remove {name} from cart",
  },
  "cart.estimatedTotal": { ar: "الإجمالي التقديري", en: "Estimated total" },
  "cart.feePending": {
    ar: "تُحسب عند تحديث الإجمالي",
    en: "Calculated with your total",
  },
  "cart.removePromotion": { ar: "إزالة كود العرض", en: "Remove offer code" },
  "cart.promotionApplied": {
    ar: "تم تطبيق الكود: {code}",
    en: "Code applied: {code}",
  },
  "cart.promotionChecking": {
    ar: "جارٍ التحقق من الكود…",
    en: "Checking code…",
  },
  "cart.updateTotal": { ar: "تحديث الإجمالي", en: "Update total" },
  "offer.loading": { ar: "جارٍ تجهيز عرضك…", en: "Preparing your offer…" },
  "offer.loadingHint": {
    ar: "سيتم نقلك إلى المتجر خلال لحظات.",
    en: "You will be taken to the storefront in a moment.",
  },
  "offer.ready": {
    ar: "تمت إضافة عرض {offer} إلى طلبك.",
    en: "The {offer} offer was added to your order.",
  },
  "offer.unavailableTitle": {
    ar: "هذا العرض غير متاح",
    en: "This offer is unavailable",
  },
  "offer.unavailable": {
    ar: "قد يكون العرض متوقفًا أو غير متاح. ما زال بإمكانك الطلب مباشرة من المتجر.",
    en: "The offer may be paused or unavailable. You can still order directly from the storefront.",
  },
  "offer.continue": {
    ar: "متابعة إلى المتجر",
    en: "Continue to storefront",
  },
  "orderType.saved": {
    ar: "تم تحديث طريقة استلام الطلب",
    en: "Order preferences updated",
  },
  "orderType.backCheckout": {
    ar: "العودة لإتمام الطلب",
    en: "Return to checkout",
  },
  "orderType.backCart": { ar: "العودة إلى السلة", en: "Return to cart" },
  "orderType.checking": {
    ar: "جارٍ التحقق من إمكانية التوصيل…",
    en: "Checking delivery availability…",
  },
  "orderType.checkError": {
    ar: "تعذّر التحقق من التوصيل. أعد المحاولة.",
    en: "We couldn’t check delivery availability. Please try again.",
  },
  "orderType.pickupPrompt": {
    ar: "اختر فرع الاستلام للمتابعة.",
    en: "Choose a pickup branch to continue.",
  },
  "orderType.noBranches": {
    ar: "لا توجد فروع تستقبل طلبات الاستلام حاليًا. اختر التوصيل إن كان متاحًا أو حاول مرة أخرى لاحقًا.",
    en: "No branches are accepting pickup orders right now. Choose delivery if available or try again later.",
  },
  "orderType.requiredHint": {
    ar: "الحقول المعلّمة بنجمة (*) مطلوبة.",
    en: "Fields marked with * are required.",
  },
  "checkout.submitting": { ar: "جارٍ إرسال طلبك…", en: "Placing your order…" },
  "checkout.completeDetails": {
    ar: "أكمل الحقول المطلوبة في بيانات الاستلام للمتابعة.",
    en: "Complete the required details above to continue.",
  },
  "checkout.invalidPickupTime": {
    ar: "اختر موعداً مستقبلياً صالحاً خلال 7 أيام.",
    en: "Choose a valid future time within 7 days.",
  },
  "checkout.preview": {
    ar: "يمكنك مراجعة الطلب في المعاينة، لكن لا يمكن تأكيده.",
    en: "You can review this order in preview, but you cannot place it.",
  },
  "account.subtitle": {
    ar: "حدّث بياناتك وعناوينك، وراجع أحدث طلباتك.",
    en: "Manage your details, saved addresses and recent orders.",
  },
  "account.profileTitle": { ar: "بياناتك الشخصية", en: "Your details" },
  "account.noAddressesHint": {
    ar: "احفظ عنوانك لتعبئة تفاصيل التوصيل بسهولة في المرة القادمة.",
    en: "Save an address to fill in delivery details faster next time.",
  },
  "account.addressSaved": { ar: "تم حفظ العنوان", en: "Address saved" },
  "account.addressDeleted": { ar: "تم حذف العنوان", en: "Address deleted" },
  "orders.subtitle": {
    ar: "تابع حالة طلباتك وراجع تفاصيل الطلبات السابقة.",
    en: "Follow your order status and revisit past orders.",
  },
  "orders.loadError": {
    ar: "تعذّر تحميل طلباتك. أعد المحاولة لعرض أحدث حالة.",
    en: "We couldn’t load your orders. Try again to see their latest status.",
  },
  "orders.refresh": { ar: "تحديث الطلبات", en: "Refresh orders" },
  "orders.viewOrder": {
    ar: "عرض تفاصيل الطلب {number}",
    en: "View order {number}",
  },
  "loyalty.walletTitle": { ar: "رصيد نقاطي", en: "Loyalty points" },
  "loyalty.walletSubtitle": {
    ar: "اعرف رصيدك وقيمة نقاطك عند استخدامها في الطلب.",
    en: "See your balance and how much your points are worth at checkout.",
  },
  "loyalty.availablePoints": { ar: "النقاط المتاحة", en: "Available points" },
  "loyalty.heldPoints": {
    ar: "النقاط المحجوزة لطلب قيد التنفيذ: {points}",
    en: "{points} points reserved for a current order",
  },
  "loyalty.rewardReady": { ar: "مكافأتك جاهزة", en: "Your reward is ready" },
  "loyalty.pointsToReward": {
    ar: "تحتاج إلى {points} نقاط إضافية لاستخدام نقاطك",
    en: "{points} more points needed to redeem",
  },
  "loyalty.pointsReady": {
    ar: "يمكنك اختيار عدد النقاط التي تريد استخدامها في طلبك التالي",
    en: "Choose how many points to use on your next order",
  },
  "loyalty.rewardValue": {
    ar: "معدل الاستبدال: {points} نقطة = خصم {amount}",
    en: "{points} points = {amount} off",
  },
  "loyalty.rewardProgress": {
    ar: "التقدم نحو مكافأة الولاء التالية",
    en: "Progress toward the next loyalty reward",
  },
  "loyalty.earnRule": {
    ar: "مقابل كل {currency} كامل تنفقه على أصناف الطلب، تكسب نقاطًا: {points}. تُضاف النقاط بعد اكتمال الطلب.",
    en: "Earn {points} points for every whole {currency} spent on completed order items.",
  },
  "loyalty.paused": {
    ar: "البرنامج موقوف مؤقتًا. رصيدك محفوظ، لكن لا يمكنك جمع النقاط أو استخدامها الآن.",
    en: "The program is paused. Your points are safe, but earning and rewards are temporarily unavailable.",
  },
  "loyalty.noProgram": {
    ar: "لم يفعّل المطعم برنامج الولاء بعد.",
    en: "The restaurant has not activated its loyalty program yet.",
  },
  "loyalty.activityTitle": { ar: "سجل نقاطي", en: "Point activity" },
  "loyalty.activity.earned": { ar: "نقاط من طلب مكتمل", en: "Points earned" },
  "loyalty.activity.held": { ar: "حجز نقاط للمكافأة", en: "Reward reserved" },
  "loyalty.activity.redeemed": {
    ar: "استخدام النقاط للمكافأة",
    en: "Reward used",
  },
  "loyalty.activity.released": {
    ar: "عادت النقاط المحجوزة إلى رصيدك",
    en: "Reserved points returned",
  },
  "loyalty.activity.adjustment": {
    ar: "تعديل الرصيد من المطعم",
    en: "Restaurant adjustment",
  },
  "loyalty.reservedChange": {
    ar: "تغيير النقاط المحجوزة: {points}",
    en: "Reserved {points}",
  },
  "loyalty.viewOrder": { ar: "عرض تفاصيل الطلب", en: "View related order" },
  "loyalty.emptyActivity": {
    ar: "لا توجد حركات على رصيد نقاطك بعد",
    en: "No point activity yet",
  },
  "loyalty.emptyActivityDescription": {
    ar: "أكمل طلبك الأول لبدء كسب النقاط.",
    en: "Complete your first order to start earning points.",
  },
  "loyalty.unavailableTitle": {
    ar: "نقاط الولاء غير متاحة حاليًا",
    en: "Loyalty is unavailable",
  },
  "loyalty.unavailableDescription": {
    ar: "هذا المطعم لا يقدّم برنامج نقاط الولاء حاليًا.",
    en: "This storefront does not currently offer a loyalty wallet.",
  },
  "loyalty.browseMenu": { ar: "تصفح المنيو", en: "Browse the menu" },
  "loyalty.cartTitle": { ar: "مكافأة الولاء", en: "Loyalty reward" },
  "loyalty.cartDiscount": { ar: "خصم مكافأة النقاط", en: "Loyalty discount" },
  "loyalty.signInToUse": {
    ar: "سجّل الدخول لمعرفة رصيدك واختيار عدد النقاط التي تريد استخدامها.",
    en: "Sign in to see your balance and choose how many points to use.",
  },
  "loyalty.rewardAvailable": {
    ar: "استبدل {points} من نقاطك واحصل على خصم {amount}.",
    en: "Use {points} points for {amount} off.",
  },
  "loyalty.applyReward": { ar: "استخدام المكافأة", en: "Apply reward" },
  "loyalty.choosePoints": {
    ar: "عدد النقاط التي تريد استخدامها",
    en: "Points to use",
  },
  "loyalty.pointRange": {
    ar: "يمكنك استخدام من {minimum} إلى {maximum} نقطة في هذا الطلب.",
    en: "Use {minimum} to {maximum} points on this order.",
  },
  "loyalty.updatePoints": { ar: "تحديث النقاط", en: "Update points" },
  "loyalty.selectionUnavailable": {
    ar: "تغيّر رصيدك أو الطلب. أزل النقاط ثم اختر عددًا مناسبًا مرة أخرى.",
    en: "Your balance or cart changed. Remove points, then choose a new amount.",
  },
  "loyalty.rewardApplied": {
    ar: "استخدمت {points} من نقاطك وحصلت على خصم {amount}.",
    en: "{points} points applied, saving {amount}.",
  },
  "loyalty.removeReward": { ar: "عدم استخدام المكافأة", en: "Remove reward" },
  "loyalty.expectedPoints": {
    ar: "النقاط التي ستُضاف بعد اكتمال الطلب: {points}",
    en: "You will earn {points} points when this order is completed.",
  },
  "loyalty.rewardUnavailable": {
    ar: "لا تتوفر قيمة كافية من الأصناف لاستخدام النقاط في هذا الطلب.",
    en: "There is not enough eligible item value to use points on this order.",
  },
  "loyalty.promotionConflict": {
    ar: "لا يمكن جمع مكافأة الولاء مع العرض الترويجي. اختر أحدهما للمتابعة.",
    en: "A loyalty reward cannot be combined with an offer. Choose one to continue.",
  },
  "loyalty.keepReward": { ar: "اختيار المكافأة", en: "Keep reward" },
  "loyalty.keepOffer": { ar: "اختيار العرض", en: "Keep offer" },
  "loyalty.errorTitle": {
    ar: "تعذّر استخدام المكافأة",
    en: "Reward could not be applied",
  },
  "loyalty.insufficientPoints": {
    ar: "رصيد نقاطك لا يكفي لاستخدام هذه المكافأة.",
    en: "Your available balance does not have enough points for this reward.",
  },
  "loyalty.customerUnavailable": {
    ar: "أكّد رقم هاتفك أولًا حتى تتمكن من استخدام نقاطك.",
    en: "Verify your phone number to use loyalty points.",
  },
  "loyalty.programUnavailable": {
    ar: "برنامج الولاء غير نشط حالياً.",
    en: "The loyalty program is not active right now.",
  },
  "loyalty.noEligibleSpend": {
    ar: "لا توجد في السلة أصناف مؤهلة لتطبيق هذا الخصم.",
    en: "There is no eligible item value for this reward.",
  },
  "loyalty.pointsExceedOrder": {
    ar: "عدد النقاط المختار أكبر من المسموح لهذا الطلب. اختر عددًا أقل.",
    en: "The selected points exceed this order's value. Choose fewer points.",
  },
  "loyalty.pointsBelowMinimum": {
    ar: "عدد النقاط المختار لا يكفي للحصول على خصم. اختر عددًا أكبر.",
    en: "The selected points are too few for a discount. Choose more points.",
  },
  "loyalty.orderTitle": {
    ar: "نقاط ومكافآت هذا الطلب",
    en: "Loyalty on this order",
  },
  "loyalty.rewardStatus": { ar: "حالة المكافأة", en: "Reward status" },
  "loyalty.orderReward.held": {
    ar: "النقاط محجوزة لهذا الطلب",
    en: "Points reserved",
  },
  "loyalty.orderReward.redeemed": {
    ar: "استُخدمت المكافأة",
    en: "Reward used",
  },
  "loyalty.orderReward.released": {
    ar: "عادت النقاط إلى رصيدك",
    en: "Points returned",
  },
  "loyalty.rewardSaving": { ar: "الخصم الذي حصلت عليه", en: "Reward saving" },
  "loyalty.pointsUsed": { ar: "النقاط المستخدمة", en: "Points used" },
  "loyalty.pointsEarned": { ar: "النقاط المكتسبة", en: "Points earned" },
  "loyalty.orderEarned": {
    ar: "النقاط التي كسبتها من الطلب: {points}",
    en: "Earned {points} points",
  },
  "loyalty.heldUntilComplete": {
    ar: "سنحجز النقاط حتى يكتمل الطلب، وستعود تلقائيًا إلى رصيدك إذا أُلغي الطلب أو رُفض.",
    en: "Points stay reserved until completion and return automatically if the order is cancelled or rejected.",
  },
  "loyalty.releasedHelp": {
    ar: "عادت النقاط إلى رصيدك لأن الطلب لم يكتمل.",
    en: "The points returned to your balance because the order did not complete.",
  },
} satisfies Record<string, Entry>;

export type TranslationKey = keyof typeof dictionary;

export function translate(
  key: TranslationKey,
  lang: "ar" | "en",
  vars?: Record<string, string | number>,
): string {
  let text: string = dictionary[key][lang];
  if (
    lang === "ar" &&
    (key === "cart.line" || key === "cart.lines") &&
    typeof vars?.["count"] === "number"
  ) {
    const forms: Record<Intl.LDMLPluralRule, string> = {
      zero: "لا توجد أصناف",
      one: "صنف واحد",
      two: "صنفان",
      few: "{count} أصناف",
      many: "{count} صنفاً",
      other: "{count} صنف",
    };
    const count = vars["count"];
    const remainder = count % 100;
    const form =
      count === 0
        ? "zero"
        : count === 1
          ? "one"
          : count === 2
            ? "two"
            : Number.isInteger(count) && remainder >= 3 && remainder <= 10
              ? "few"
              : Number.isInteger(count) && remainder >= 11 && remainder <= 99
                ? "many"
                : "other";
    text = forms[form];
  }
  for (const [name, value] of Object.entries(vars ?? {}))
    text = text.split(`{${name}}`).join(String(value));
  return text;
}
